import { useDispatch, useSelector } from "react-redux"
import { CHECKBOX, COLLAPSE, COMBOBOX, IMAGEGROUP, IMAGESINGLE, PASSWORD, RADIOBUTTON, TEXTAREA, TEXTFIELD, LINKWIDGET, CUSTOMCOMBOBOX, TEXTFIELDNEW } from "../../utils/Constants"
import ComboBoxField from "./ComboBoxField"
import UMCAttrImageGroup from "./UMCAttrImageGroup"
import PasswordField from "./PasswordField"
import RadioButton from "./RadioButton"
import SingleImage from "./SingleImage"
import TextField from "./TextField"
import TextFieldNew from "./TextFieldNew"
import LinkWidget from "./LinkWidget"
import UMCTextArea from "./UMCTextArea"
import _ from "lodash"
import { setCurrentMergedData, setCurrModalMergedData } from "../../store/reducers/CommonReducer"
import UMCCheckbox from "./UMCCheckbox"
import { findInObjectById, updateValueById, validateLinks } from "../../utils/SchemaParseUtils"
import CustomCombobox from "./CustomCombobox"

/**
 * 
 * @param {Object} attribute
 * attribute.isModalView if true, schema data will be taken from currModalMergedData, instead of from currentMergedData for attribute update
 * @returns {React.ReactNode}
 */

const UMCAttributeView = ({ attribute }) => {

    const currentMergedData = useSelector((state) => state.common.currentMergedData) // It's used as a default schema data
    const currModalMergedData = useSelector((state) => state.common.currModalMergedData) // If isModalView is set to true, it'll be used
    const baseMergeData = useSelector((state) => state.common.baseMergeData) // Object value right after API response without any change

    const dispatch = useDispatch()

    const handleSchemaDataChange = (attribute, value) => {
        
        const mergedData = attribute.isModalView ? currModalMergedData : currentMergedData
        if (mergedData) {
            let tempObj = _.cloneDeep(mergedData)
            const foundObj = findInObjectById(baseMergeData, attribute.id)
            tempObj = updateValueById(tempObj, attribute.id, value, foundObj)

            if (tempObj?.isLink) //If attr with link variable[isLink==true] is changed, validate links with the latest value
                tempObj = validateLinks(tempObj?.obj)
            else
                tempObj = tempObj?.obj
            dispatch(attribute.isModalView ? setCurrModalMergedData(tempObj) : setCurrentMergedData(tempObj))
        }
    }

    const getView = () => {
        const tempAttr = {
            ...attribute,
            handleSchemaDataChange: attribute.customHandleDataChange ? (attribute, value) => attribute.customHandleDataChange(attribute, value) : (attribute, value) => handleSchemaDataChange(attribute, value)
        }

        switch (tempAttr.widget) {
            case TEXTFIELD: return <TextField {...tempAttr} />
            case TEXTFIELDNEW: return <TextFieldNew {...tempAttr} />
            case TEXTAREA: return <UMCTextArea {...tempAttr} />
            case COMBOBOX: return <ComboBoxField {...tempAttr} />
            case PASSWORD: return <PasswordField {...tempAttr} />
            case CHECKBOX: return <UMCCheckbox {...tempAttr} />
            case IMAGEGROUP: return <UMCAttrImageGroup {...tempAttr} />
            case IMAGESINGLE: return <SingleImage {...tempAttr} />
            case RADIOBUTTON: return <RadioButton {...tempAttr} />
            case LINKWIDGET: return <LinkWidget {...tempAttr} />
            case CUSTOMCOMBOBOX: return <CustomCombobox {...tempAttr} />
            case COLLAPSE: return <></>
            default: return <></>
        }
    }


    return (attribute.widget !== "NONE" && attribute.access !== "INTERNAL") ? getView() : <></>

}

export default UMCAttributeView